export default "__VITE_ASSET__a0b7fc12__"